module.exports = __webpack_public_path__ + "static/campaign-logo-f889cd73f96261bb346e7dc5e7ca3fc2.svg";